import { render } from "./MainMenuAdmin.vue?vue&type=template&id=36ebb070&scoped=true&ts=true"
import script from "./MainMenuAdmin.vue?vue&type=script&lang=ts"
export * from "./MainMenuAdmin.vue?vue&type=script&lang=ts"

import "./MainMenuAdmin.vue?vue&type=style&index=0&id=36ebb070&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ebb070"]])

export default __exports__